import React from 'react';
import { X, Check } from 'lucide-react';
export function ComparisonSection() {
  return <section className="bg-white py-16 px-4" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-22">
          🔄 Antes vs Después
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-23">
          {/* Before */}
          <div className="bg-red-50 p-8 rounded-2xl border-2 border-red-100" data-id="element-24">
            <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-25">
              <span className="bg-red-100 p-1 rounded" data-id="element-26">❌</span> Antes del
              MegaPack
            </h3>
            <ul className="space-y-4" data-id="element-27">
              {['Miedo al taller', 'Gastos inesperados', 'Dudas constantes', 'Falta de control', 'Decisiones apuradas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700 text-lg" data-id="element-28">
                  <X className="w-5 h-5 text-red-500" data-id="element-29" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-green-50 p-8 rounded-2xl border-2 border-green-100 shadow-xl transform md:-translate-y-4" data-id="element-30">
            <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-31">
              <span className="bg-green-100 p-1 rounded" data-id="element-32">✅</span> Después del
              MegaPack
            </h3>
            <ul className="space-y-4" data-id="element-33">
              {['Seguridad al hablar con un mecánico', 'Menos gastos innecesarios', 'Problemas detectados a tiempo', 'Control total de tu vehículo', 'Tranquilidad real'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-800 text-lg font-medium" data-id="element-34">
                  <Check className="w-6 h-6 text-green-600 font-bold" data-id="element-35" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}